export function generateAssetReadme(): string {
  return `Add your own icon files for the generated manifest:

- public/icon-192.png
- public/icon-512.png

You can replace the manifest icon paths in go-offline.config.ts if you already have brand assets.
`;
}
